/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Toss_Min_RoundsInputs */



/**
* | output |
* | --- |
* | "Need at least 2 rounds before setting toss" |
*
* @param {Err_Tournament_Toss_Min_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_toss_min_rounds = /** @type {((inputs?: Err_Tournament_Toss_Min_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Toss_Min_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins 2 rondes sont nécessaires avant de définir le toss")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se necesitan al menos 2 rondas antes de establecer el sorteo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("São necessárias pelo menos 2 rodadas antes de definir o toss")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sono necessari almeno 2 round prima di impostare il toss")
	return /** @type {LocalizedString} */ ("Need at least 2 rounds before setting toss")
});